<template>
    <div>
        <property-reservation-setup :setup_parameter="SETUP_PARAMETER_DATA_TRANSITION_AFTER_EVENT"></property-reservation-setup>
    </div>
</template>

<script>


import {SETUP_PARAMETER_DATA_TRANSITION_AFTER_EVENT} from "@/shared/constants";

export default {
    name: "Index",
    components: {
        "PropertyReservationSetup": () => import("@/components/property/reservation_setup/PropertyReservationSetup")
    },
    data(){
        return {
            SETUP_PARAMETER_DATA_TRANSITION_AFTER_EVENT
        }
    }
}
</script>

<style scoped>

</style>
